import React from 'react'
import YouTubePlaylist from "@codesweetly/react-youtube-playlist";
import Footer from "../Components/Footer"

function Videos() {
    return (
        <div>
        <div className='max-w-[1240px] mx-auto py-3 px-4'>
           <h2 className='font-semibold md:text-3xl sm:text-2xl text-xl py-2 text-center'>Видео из посёлка Сырдарьинский</h2>
            <p className='text-left mx-auto py-2'>Видео, снятое в 2012 году, во время посещения родных мест Викторией и Александром Нагель(Сенкевич)</p>
            <YouTubePlaylist
                apiKey="AIzaSyBp3pdAuoeGMTZI-r2fWI4teP8Yc1EiQT8"
                playlistId="PLzTbx4TWNlml-9Zy5BKgJMB2PKpP3Wi5T"
                uniqueName="Poselok2012"
            />
            <h2 className='font-semibold md:text-3xl sm:text-2xl text-xl py-2 text-center'>Видеоклипы</h2>
            <p className='text-left mx-auto py-1'>Некоторые из песен на слова А.Наумова</p>
            <YouTubePlaylist
                apiKey="AIzaSyBp3pdAuoeGMTZI-r2fWI4teP8Yc1EiQT8"
                playlistId="PLzTbx4TWNlmncISv-U5DUGQ4lWr087-wh"
                uniqueName="Избранные песни"
            />
            </div>
            <Footer />
        </div>

    )
}

export default Videos